import { Injectable, signal } from '@angular/core';

/**
 * Simple service to manage navigation state across route changes.
 * Uses in-memory signals instead of browser APIs.
 */
@Injectable({
  providedIn: 'root',
})
export class NavigationStateService {
  /**
   * Stores the selected toggle state (Countries or Regions)
   * Persists across navigation until explicitly changed
   */
  private readonly _selectedToggle = signal<'Countries' | 'Regions'>('Countries');
  public readonly selectedToggle = this._selectedToggle.asReadonly();

  /**
   * Sets the selected toggle state
   */
  setSelectedToggle(value: 'Countries' | 'Regions'): void {
    this._selectedToggle.set(value);
  }

  /**
   * Gets the current selected toggle state
   */
  getSelectedToggle(): 'Countries' | 'Regions' {
    return this._selectedToggle();
  }
}
